<!-- This button has two parts -- the left side of the button is the default action, the right side displays an option menu -->
<script lang="ts">
    import { propsToAttrMap } from "@vue/shared";
import { defineComponent, PropType } from "vue";
    import { ListNames } from "../Enums/ChoiceEnums";
    import { list } from '../lib/ChoiceApi';
    import { IListByNameExtended, IListByNameItem } from '../lib/Models/SearchModel';

    export default defineComponent({
        name: "SelectMultiple",
        emits:["onChange","onSelected"],

        data() {
            return {
                searchText: "",
                listResults: [] as IListByNameExtended[]
            };
        },

        props: {
            // Label for the component
            label: {
                type: String,
                default: ""
            },
            // The maximum height of the search results
            maxHeight: {
                type: Number,
                default: 200
            },
            listName: {
                type: String as PropType<ListNames>,
                required: false 
            },
            clear: {
                type: Boolean,
                default: false
            },
            addToList: {
                type: Object as () => IListByNameExtended,
                default: undefined
            },
            addToBaseClass: {
                type: String,
                default: ""
            },
            addDefaultList: {
                type: Object as () => IListByNameExtended[],
                default: undefined
            }
        },

        async mounted() {
            if (this.listName != ListNames.Empty) {
                const listResponse = await list.getListByName(this.listName);
                this.listResults = listResponse.list || [];
            }
            else {
                this.listResults = this.addDefaultList || [];
            }            
        },

        watch: {
            clear(newValue, oldValue) {
                let filterList = this.listResults.filter(i => i.selected === true);
                filterList.forEach(function(item) {
                    item.selected = false;
                });
            },
            addToList: {
                handler: function (newValue, oldValue) {
                    const foundIndex = this.listResults.findIndex((element) => {
                        return element.identifier == newValue.identifier && element.optionalIdentifier == newValue.optionalIdentifier;
                    });

                    if (foundIndex == -1) {
                        let index = this.listResults.findIndex((element) => element.optionalIdentifier == newValue.optionalIdentifier);
                        // If an optionalIdentifier is defined then add the group
                        if (index == -1 && newValue.optionalIdentifier != "") {
                            let headerValue = {...newValue};
                            headerValue.identifier = headerValue.optionalIdentifier;
                            headerValue.header = true;
                            headerValue.selected = false;
                            this.listResults.splice(0, 0, headerValue)
                            index = 0;
                        }
                        this.listResults.splice(index + 1, 0, {...newValue});
                    }
                    else {
                        this.listResults[foundIndex].selected = true;
                    }
                    this.emitChanges();
                }, deep: true
            }
        },

        computed:
        {            
            displayLabel() {return this.label.length > 0 ? true : false;},
            labelBaseClass() {return this.addToBaseClass;},
            inputBaseClass() {return `form-check-input ms-2 me-1 ${this.addToBaseClass}`;},
            itemBaseClass() {return `list-group-item-small list-group-item-action pt-0 ${this.addToBaseClass}`;},
        },

        methods:{
            onChange: function(value: Event, index: number) {
                this.listResults[index].selected = (value.target as HTMLInputElement)?.checked;
                this.emitChanges();
            },
            headerClass: function(index: number) {
                return `bg-light ps-2 border-bottom w-100${index > 0 ? " border-top" : ""} ${this.addToBaseClass}`;
            },
            emitChanges: function() {
                this.$emit("onChange", this.listResults);
                let filterList = this.listResults.filter(i => i.selected === true);
                this.$emit("onSelected", filterList);
            }
        }
    })
</script>

<template>
    <label v-if="displayLabel" :class="labelBaseClass">{{label}}</label>
    <div class="list-group-small overflow-auto border" :style="{maxHeight: maxHeight + 'px'}">
        <div v-for="(item, index) in listResults">
            <label v-if="item.header" :class="headerClass(index)">{{item.display}}</label>
            <label v-if="!item.header" :class="itemBaseClass">
                <input :class="inputBaseClass" type="checkbox" value="" @input="(evt) => onChange(evt, index)" v-model="listResults[index].selected">
                {{item.display}}
            </label>
        </div>
    </div>
</template>